'use strict';
import { throttle, debounce } from 'throttle-debounce'

export class ScaleControl {
  constructor (element, svg){
    this.$control = document.createElement('div')
    this.$control.classList.add('si_controls__control')
    this.$control.classList.add('si_control')
    this.$control.classList.add('si_control--scale')


    const $label = document.createElement('label')
    $label.classList.add(`si_control__label`)
    if(document.documentElement.lang == 'en'){
      $label.innerHTML = 'Image scale'
    }else{
      $label.innerHTML = 'Taille de la photo'
    }

    this.min = .5
    this.max = 1.5
    this.step = .01
    this.$input = document.createElement('input')
    this.$input.classList.add('si_control__input')
    this.$input.classList.add('si_input')
    this.$input.classList.add('si_input--scale')
    this.$input.setAttribute('type', 'range')
    this.$input.setAttribute('min', this.min)
    this.$input.setAttribute('max', this.max)
    this.$input.setAttribute('step', this.step)
    this.$input.value = 1

    this.$control.appendChild($label)
    $label.appendChild(this.$input)

    this.originScale = element.transform().localMatrix.split().scalex
    this.imageSize = {w : parseFloat(element.attr('width')), h : parseFloat(element.attr('height'))}

    this.makeDraggable(element, svg)

    this.$input.addEventListener('input', (e) => {
      this.scale(element, parseFloat(e.target.value))
    })

    this.$input.addEventListener('change', (e) => {
      const value = Math.max(Math.min(parseFloat(e.target.value), this.max), this.min)
      this.setValue(value)

      this.scale(element, value)
    })

    this.reset = this.reset.bind(this, element)

    return this
  }

  scale(element, scaleFactor) {
    let matrix = element.transform().localMatrix

    scaleFactor = this.originScale * 1 / matrix.split().scalex * scaleFactor

    matrix.scale(scaleFactor, scaleFactor, this.imageSize.w / 2, this.imageSize.h / 2)
    element.transform(matrix)

    element.data('currentTransform', element.transform().local)

    return this
  }

  makeDraggable(element, svg) {
    element.data('origTransform', element.transform().local )

    let globalRatio = svg.getBBox().w / svg.node.getBoundingClientRect().width
    window.addEventListener('resize', debounce(300, () => {
      globalRatio = svg.getBBox().w / svg.node.getBoundingClientRect().width
    }))

    element.drag(
      // Moving
      (dx, dy) => {
          element.transform(element.data('currentTransform') + (element.data('currentTransform') ? "T" : "t") + [dx*globalRatio, dy*globalRatio])
      },
      // Start
      () => { element.data('currentTransform', element.transform().local ) },
      // Stop
      () => {}
    )

    element.dblclick(() => {
      this.reset(element)
    })

    return this
  }

  getElement() {
    return this.$control
  }

  setValue(value) {
    this.$input.value = value

    return this
  }

  getValue() {
    return parseFloat(this.$input.value)
  }

  reset(element) {
    element.transform(element.data('origTransform'))
    this.setValue(1)

    return this
  }
}
